export default "__VITE_ASSET__DSqHAk$y__"